export const HOME = {
  emergentLink: "emergent-link",
};

export const HEADER = {
  logo: "header-logo",
  ctaButton: "header-cta-button",
};

export const HERO = {
  title: "hero-title",
  subtitle: "hero-subtitle",
  searchInput: "hero-search-input",
  searchDropdown: "hero-search-dropdown",
  nameInput: "hero-name-input",
  emailInput: "hero-email-input",
  phoneInput: "hero-phone-input",
  submitButton: "hero-submit-button",
  errorNotice: "hero-error-notice",
};

export const DESIGN_STUDIO = {
  container: "design-studio-container",
  sizeA4: "size-a4",
  sizeA5: "size-a5",
  presetDropdown: "preset-dropdown",
  customTextInput: "custom-text-input",
  livePreview: "live-preview",
  qrCode: "qr-code-preview",
  downloadPdfButton: "download-pdf-button",
  copyLinkButton: "copy-link-button",
  shareLinkButton: "share-link-button",
};

export const TESTIMONIALS = {
  container: "testimonials-container",
  card: "testimonial-card",
  microCta: "testimonials-micro-cta",
};

export const FAQ = {
  container: "faq-container",
  item: "faq-item",
};

export const FOOTER = {
  container: "footer-container",
  statement: "footer-statement",
  ctaButton: "footer-cta-button",
};
